import script from "./CountdownBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CountdownBar.vue?vue&type=script&setup=true&lang=js"

import "./CountdownBar.vue?vue&type=style&index=0&id=c3a6e816&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a6e816"]])

export default __exports__